/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Archived_LabelInputs */

const en_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

const fr_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const de_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviert`)
};

const it_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviato`)
};

const ru_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Архив`)
};

const es_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivado`)
};

const zh_cn2_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已存档`)
};

const ja_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ済み`)
};

const hi_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संग्रहीत`)
};

const pt_pt2_explorer_kanban_archived_label = /** @type {(inputs: Explorer_Kanban_Archived_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivado`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Explorer_Kanban_Archived_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_archived_label = /** @type {((inputs?: Explorer_Kanban_Archived_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Archived_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_archived_label(inputs)
	if (locale === "de") return de_explorer_kanban_archived_label(inputs)
	if (locale === "it") return it_explorer_kanban_archived_label(inputs)
	if (locale === "ru") return ru_explorer_kanban_archived_label(inputs)
	if (locale === "es") return es_explorer_kanban_archived_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_archived_label(inputs)
	if (locale === "ja") return ja_explorer_kanban_archived_label(inputs)
	if (locale === "hi") return hi_explorer_kanban_archived_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_archived_label(inputs)
	return en_explorer_kanban_archived_label(inputs)
});